import moment from "moment";
import { useState } from "react";
import {
  useLocation,
  withRouter,
} from "react-router-dom/cjs/react-router-dom.min";
import {
  Button,
  ButtonGroup,
  Col,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
} from "reactstrap";
import { GetLanguageString } from "../../../helper/Components";
import { GetCustomStyles, GetSelectedLanguage } from "../../../helper/Method";
import EventAttendeesList from "./EventAttendeesList";
import EventSummary from "./EventSummary";
import { decryptData } from "../../../../constants/EncryptData";

const EventSummaryReport = ({ history }) => {
  const location = useLocation();

  const queryParams = new URLSearchParams(location.search);
  const encryptedData = queryParams.get("data");

  // Prefer decrypted data if exists, otherwise fallback to location.state
  const state = encryptedData
    ? decryptData(encryptedData)
    : location.state ?? {};

  // Destructure safely
  const {
    eventId,
    eventAddress,
    eventDate,
    eventType,
    eventUnitId,
    eventUnitType,
    eventFilterExist,
    showListTab,
  } = state;

  console.log(
    eventId,
    eventAddress,
    eventDate,
    eventType,
    eventUnitId,
    eventUnitType,
    eventFilterExist,
    showListTab
  );

  const [activeTab, setActiveTab] = useState(
    showListTab ? "attendeesList" : "summary"
  );

  const toggle = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  return (
    <div className="wrapper-custom wrapper wrapper-content animated fadeInRight">
      <div className="panel panel-success shadow border-0 rounded-lg overflow-hidden">
        <div className="panel-heading">
          <h4>
            <GetLanguageString props="events_summary" />
          </h4>
          {!!location.state ? (
            <ButtonGroup className={GetCustomStyles().btn_style}>
              <Button
                color="info"
                size="sm"
                onClick={() => history.goBack()}
                style={{ marginTop: -30 }}
              >
                <i className="fa fa-arrow-left me-2" />
                <GetLanguageString props="courses_participants_back" />
              </Button>
            </ButtonGroup>
          ) : null}
        </div>

        <div className="panel-body">
          <Row>
            <Col md="4">
              <div className="p-2 shadow-sm rounded border">
                <h4>
                  <GetLanguageString props="events_name" />
                </h4>
                <h2 className="fw-bold  ur">{eventType}</h2>
              </div>
            </Col>
            <Col md="4">
              <div className="p-2 shadow-sm rounded border">
                <h4>
                  <GetLanguageString props="member_address" />
                </h4>
                <h2 className="fw-bold  ur">{eventAddress}</h2>
              </div>
            </Col>
            <Col md="4">
              <div className="p-2 shadow-sm rounded border">
                <h4>
                  <GetLanguageString props="dashboard_event_page_date" />
                </h4>
                <h2 className="fw-bold">
                  {moment(eventDate)
                    .locale(GetSelectedLanguage())
                    .format("DD/MM/yyyy  h:mm a")}
                </h2>
              </div>
            </Col>
          </Row>
        </div>
      </div>

      <div className="tabs-container">
        <Nav tabs>
          {showListTab ? (
            <NavItem>
              <NavLink
                className={activeTab === "attendeesList" ? "active" : ""}
                onClick={() => toggle("attendeesList")}
                style={{ cursor: "pointer" }}
              >
                <GetLanguageString props="events_summary_attendees" />
              </NavLink>
            </NavItem>
          ) : null}
          <NavItem>
            <NavLink
              className={activeTab === "summary" ? "active" : ""}
              onClick={() => toggle("summary")}
              style={{ cursor: "pointer" }}
            >
              <GetLanguageString props="events_summary_summary" />
            </NavLink>
          </NavItem>
        </Nav>
        <TabContent activeTab={activeTab}>
          <TabPane tabId="attendeesList">
            <div className="panel-body">
              <EventAttendeesList
                activeTab={activeTab}
                eventId={eventId}
                eventUnitId={eventUnitId}
                eventUnitType={eventUnitType}
                eventType={eventType}
                eventAddress={eventAddress}
              />
            </div>
          </TabPane>
          <TabPane tabId="summary">
            <div className="panel-body">
              <EventSummary
                activeTab={activeTab}
                eventId={eventId}
                eventUnitId={eventUnitId}
                eventUnitType={eventUnitType}
                eventFilterExist={eventFilterExist}
              />
            </div>
          </TabPane>
        </TabContent>
      </div>
    </div>
  );
};

export default withRouter(EventSummaryReport);
